import { ILineItem } from '../types/line-item.types';
import { ILineItemUpdate } from '../types/verify-travel.types';

export const processLineItems = (items: ILineItem[]) => {
    const reviewRequiredIds = new Set<number>();
    const reviewRequiredStateMap = new Map<number, boolean>();
    const lineItemStateMap = new Map<number, Partial<ILineItem>>();

    items.forEach(item => {
        if (item.reviewRequired) {
            reviewRequiredIds.add(item.id);
        }
        reviewRequiredStateMap.set(item.id, item.reviewRequired);
        lineItemStateMap.set(item.id, {
            id: item.id,
            description: item.description,
            amount: item.amount,
            expenseType: item.expenseType,
            expenseDate: item.expenseDate,
            reviewRequired: item.reviewRequired,
            receiptFileId: item.receiptFileId,
            isCaregiverExpense: item.isCaregiverExpense
        });
    });

    return {
        reviewRequiredIds,
        reviewRequiredStateMap,
        lineItemStateMap
    };
};

export const buildLineItemUpdates = (
    lineItems: ILineItem[],
    lineItemState: Map<number, Partial<ILineItem>>,
    reviewRequiredState: Map<number, boolean>
): ILineItemUpdate[] => {
    const updates: ILineItemUpdate[] = [];

    lineItems.forEach(li => {
        const stateChanges = lineItemState.get(li.id);
        const reviewRequiredStateValue = reviewRequiredState.get(li.id);

        const update: ILineItemUpdate = {
            lineItemId: li.id
        };

        if (reviewRequiredStateValue !== undefined) {
            update.reviewRequired = reviewRequiredStateValue;
        } else if (stateChanges?.reviewRequired !== undefined) {
            update.reviewRequired = stateChanges.reviewRequired;
        } else {
            update.reviewRequired = li.reviewRequired;
        }

        if (stateChanges) {
            if (stateChanges.description !== undefined) update.description = stateChanges.description;
            if (stateChanges.amount !== undefined) update.amount = stateChanges.amount;
            if (stateChanges.expenseType !== undefined) update.expenseType = stateChanges.expenseType;
            if (stateChanges.expenseDate !== undefined) update.expenseDate = stateChanges.expenseDate;
            if (stateChanges.receiptFileId !== undefined) update.receiptFileId = stateChanges.receiptFileId;
            if (stateChanges.isCaregiverExpense !== undefined) update.isCaregiverExpense = stateChanges.isCaregiverExpense;
        }

        if (update.description === undefined && li.description !== undefined) update.description = li.description;
        if (update.amount === undefined && li.amount !== undefined) update.amount = li.amount;
        if (update.expenseType === undefined && li.expenseType !== undefined) update.expenseType = li.expenseType;
        if (update.expenseDate === undefined && li.expenseDate !== undefined) update.expenseDate = li.expenseDate;
        if (update.notes === undefined && (li as any).notes !== undefined) update.notes = (li as any).notes;
        if (update.isCaregiverExpense === undefined && li.isCaregiverExpense !== undefined) update.isCaregiverExpense = li.isCaregiverExpense;

        updates.push(update);
    });

    return updates;
};

